/**
 * Error thrown by TrackingPixels.update() on API failure.
 * Extends Error to preserve stack traces and allow standard catch handling.
 *
 * - isPartialFailure=false: all creatives for the line item failed
 * - isPartialFailure=true: only some creatives failed (failedCreatives populated)
 */
export class TrackingPixelsUpdateError extends Error {
    constructor({ message, isPartialFailure, failedCreatives }) {
        super(message);
        this.name = "TrackingPixelsUpdateError";
        this.isPartialFailure = isPartialFailure;
        this.failedCreatives = failedCreatives;
    }
}
//# sourceMappingURL=types.js.map